import ReactDOM from "react-dom/client"
import App from "./App"

/* CSS */
import "./design/css/app.css"
import "./design/css/stand.css"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<App />)
